<template><v-navigation-drawer :rail="!menuOpen" mobile-breakpoint="false" width="222" class="nav-drawer" rail-width="56">
  <template #prepend>
    <div class="logo-container pa-2 pt-4 d-flex justify-center align-center" style="height: 70px;">
      <v-img v-if="menuOpen" :alt="organization ? organization.name : ''" :class="darkMode ? 'inverted-image' : ''" :src="logo" height="60" width="180" class="logo-image" />
      <v-avatar v-else size="32" rounded="0">
        <v-img :alt="organization ? organization.name : ''" :src="icon" max-width="32" />
      </v-avatar>
    </div>
    <v-list-item v-if="showControlPanel" style="height: 38px">
      <v-btn v-if="menuOpen" variant="outlined" color="grey-lighten-2" class="mx-auto" size="small" width="160" @click="openControlPanel">
        <span class="text-grey-darken-1">Control Panel</span>
        <v-icon size="small" class="ml-4" color="grey-darken-1">mdi-open-in-new</v-icon>
      </v-btn>
      <v-btn v-else variant="outlined" color="grey-lighten-2" class="mx-auto" size="small" icon @click="openControlPanel">
        <v-icon color="">mdi-account-supervisor-outline</v-icon>
      </v-btn>
    </v-list-item>
    <v-divider class="ma-2 mx-3"></v-divider>
  </template>
  <v-list id="side-nav" v-model="open" class="pt-0 pl-2">
    <template v-for="item in mappedItems">
      <v-row v-if="item.heading" :key="item.heading" no-gutters>
        <v-col cols="12">
          <v-list-subheader v-if="item.heading" class="font-weight-bold text-caption px-4">
            {{ item.heading }}
          </v-list-subheader>
        </v-col>
      </v-row>
      <v-divider v-else-if="item.divider" :key="item.divider" class="ma-2 mx-3"></v-divider>
      <v-list-group v-else-if="item.children" :key="item.text" :to="item.path" link>
        <template #activator="{ props }">
          <v-list-item v-bind="props" :title="item.text" class="navbar-link with-child mx-1 pa-1 rounded text-body-2" :active="checkRoute(item.path)">
            <template #prepend>
              <v-icon :icon="item.icon" size="small"></v-icon>
            </template>

            <template v-if="item.status" #append>
              <v-chip :color="item.status == 'Online' ? 'success' : 'red'" size="x-small">
                {{ item.status }}
              </v-chip>
            </template>
          </v-list-item>
        </template>
        <template v-for="(child, i) in item.children">
          <v-list-group v-if="child.children" :value="child.text" :key="i">
            <template #activator="{ props }">
              <v-list-item v-bind="props" :value="child.text" :title="child.text" class="navbar-link mx-1 rounded text-body-2" :active="checkRoute(child.path)">
                <template #prepend>
                  <v-icon :icon="child.icon" size="small"></v-icon>
                </template>
              </v-list-item>
            </template>
            <v-list-item v-for="(grandchild, j) in child.children" :key="j" :value="grandchild.text" :title="grandchild.text" class="navbar-link grandchild mx-1 rounded text-caption" link :to="grandchild.path" :prepend-icon="grandchild.icon" @click="grandchild.click ? grandchild.click() : () => { }"></v-list-item>
          </v-list-group>
          <v-list-item v-else :key="`${item.text}-${i}`" :value="child.text" :title="child.text" class="navbar-link mx-1 rounded text-body-2" link :to="child.path" :prepend-icon="child.icon" @click="child.click ? child.click() : () => { }"></v-list-item>
        </template>
      </v-list-group>
      <v-list-item v-else :key="`${item.text}-nochild`" link :to="item.path" class="navbar-link no-child mx-1 pa-1 rounded text-body-2" :active="checkRoute(item.path)" @click="item.click ? item.click() : () => { }">
        <template #prepend>
          <v-icon :icon="item.icon"></v-icon>
        </template>
        <v-list-item-title v-if="menuOpen" class="showOverflow text-body-1">
          {{ item.text }}
        </v-list-item-title>
        <template v-if="item.text == 'Messaging'" #append>
          <v-progress-circular v-if="getUnreadMessageCount == null && !menuOpen" indeterminate color="grey-lighten-2" size="18" width="2" />
          <v-avatar v-else-if="getUnreadMessageCount > 0" :color="renderBadgeColor(item)" size="18">
            <span v-if="getUnreadMessageCount < 99" class="v-badge__badge white-text text-caption" v-text="getUnreadMessageCount"></span>
            <span v-else class="v-badge__badge white-text text-caption">99+</span>
          </v-avatar>
        </template>

        <template v-if="item.status" #append>
          <v-chip :color="item.status == 'Online' ? 'success' : 'red'" size="x-small">
            {{ item.status }}
          </v-chip>
        </template>
      </v-list-item>
    </template>
  </v-list>

  <template #append>
    <v-list-item>
      <template #append>
        <v-btn class="float-right" icon size="x-small" variant="text" @click.stop="toggleMenu">
          <v-icon>{{ menuOpen ? "mdi-chevron-left" : "mdi-chevron-right" }}</v-icon>
        </v-btn>
      </template>
    </v-list-item>
    <v-list class="py-0 px-2 border-t">
      <v-list-item to="/notifications" class="mx-1 pa-1 rounded text-body-2 submenu-item bg-transparent">
        <template #prepend>
          <v-badge color="primary" :content="getUnreadCount" :model-value="getUnreadCount > 0" dot>
            <v-icon color="grey" size="small">mdi-bell-outline</v-icon>
          </v-badge>
        </template>
        <v-list-item-title class="text-grey">Notifications</v-list-item-title>
      </v-list-item>
      <v-list-item @click="toggleBottomMenu" class="mx-1 px-1 rounded text-body-2">
        <template #prepend>
          <Avatar v-if="user" :user="user" size="24" />
          <v-icon v-else color="grey-lighten-1" size="small">mdi-account-outline</v-icon>
        </template>
        <v-list-item-title class="text-grey pl-2" v-text="renderUserName || 'Profile'"></v-list-item-title>
        <template v-if="menuOpen" #append>
          <v-icon size="x-small" :class="{ 'rotate-icon': bottomMenuOpen }">mdi-chevron-down</v-icon>
        </template>
      </v-list-item>

      <v-expand-transition>
        <div v-if="menuOpen && bottomMenuOpen" class="bottom-menu-content">
          <v-list-item :to="`/users/${encodedID}`" class="mx-1 pa-1 rounded text-body-2 submenu-item bg-transparent">
            <template #prepend>
              <v-icon color="grey-lighten-1" size="small">mdi-account-edit-outline</v-icon>
            </template>
            <v-list-item-title class="text-grey">Edit Profile</v-list-item-title>
          </v-list-item>
          <v-list-item to="/settings/changelog" class="mx-1 pa-1 rounded text-body-2 submenu-item bg-transparent">
            <template #prepend>
              <v-icon color="grey-lighten-1" size="small">mdi-text-box-multiple-outline</v-icon>
            </template>
            <v-list-item-title class="text-grey">Changelog</v-list-item-title>
            <template v-if="hasUnreadChangelogEntries" #append>
              <v-icon size="small">mdi-bell-outline</v-icon>
            </template>
          </v-list-item>
          <v-list-item class="mx-1 pa-1 rounded text-body-2 submenu-item bg-transparent" @click="dialog = true">
            <template #prepend>
              <v-icon color="grey" size="small">mdi-help-circle-outline</v-icon>
            </template>
            <v-list-item-title class="text-grey">Support</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout" class="mx-1 pa-1 rounded text-body-2 submenu-item bg-transparent">
            <template #prepend>
              <v-icon color="grey-lighten-1" size="small">mdi-logout-variant</v-icon>
            </template>
            <v-list-item-title class="text-grey">Log Out</v-list-item-title>
          </v-list-item>
        </div>
      </v-expand-transition>
    </v-list>
  </template>
  <v-dialog v-model="dialog" max-width="290">
    <v-card>
      <v-card-text class="d-flex justify-center pa-6">
        <v-container fluid class="pa-0">
          <v-row class="d-flex justify-center">
            <v-btn href="mailto:support@carelaunch.health" class="ma-2 px-6 text-none" variant="outlined" size="x-large" color="primary" width="235px">
              <v-icon start>mdi-email-outline</v-icon>
              Email Support
            </v-btn>
          </v-row>
          <v-row class="d-flex justify-center">
            <v-btn class="ma-2 px-6 text-none" variant="outlined" size="x-large" color="primary" href="https://docs.carelaunch.health/docs/intro" target="_blank" rel="noopener noreferrer" width="235px">
              <v-icon start>mdi-file-document-outline</v-icon>
              Documentation
            </v-btn>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-container id="ccp"></v-container>
</v-navigation-drawer></template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { AUTH_LOGOUT } from "../store/auth/mutation-types";
import { LOAD_ORGANIZATION } from "../store/organization/mutation-types";
import { LOAD_COUNTS } from "../store/messaging/mutation-types";
import { useNotificationsStore } from "@/store/notifications";
import Avatar from "./shared/avatar.vue";
import Intercom from '@intercom/messenger-js-sdk';

const prefixes = ["Mr.", "Ms.", "Mrs.", "Dr."];

export default {
  components: {
    Avatar,
  },
  name: "AdminDrawer",
  inject: ["checkFeature", "can"],
  data: () => ({
    dialog: false,
    org: null,
    drawer: null,
    open: [],
    dark: null,
    loading: false,
    polling: null,
    menuOpen: true,
    bottomMenuOpen: true,
    staticIcon: "/square.png",
    staticLogo: "/CareLaunch-Logo.png",
    items: [
      // { heading: "Navigation" },
      { icon: "mdi-home-outline", text: "Home", path: "/home" },
      {
        icon: "mdi-view-dashboard-outline",
        text: "Dashboard",
        path: "/dashboard",
        roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
      },
      {
        icon: "mdi-domain",
        text: "Organizations",
        path: "/organizations",
        feature: "organizations",
        roles: ["Orbital-Platform-Admin"],
      },
      { divider: true },
      { heading: "Care Management" },
      {
        icon: "mdi-view-column-outline",
        text: "Board",
        feature: "board",
        path: "/board",
        roles: ["Orbital-Platform-Admin"],
      },
      {
        icon: "mdi-order-bool-descending-variant",
        text: "Tasks",
        feature: "tasks",
        path: "/tasks",
        roles: ["Orbital-Platform-Admin"],
      },
      {
        icon: "mdi-account-multiple-outline",
        text: "Patients",
        path: "/patients",
      },
      {
        icon: "mdi-stethoscope",
        text: "Providers",
        path: "/providers",
        roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
      },
      {
        icon: "mdi-clipboard-text-outline",
        text: "Requests",
        path: "/servicerequests",
        roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
      },
      { divider: true },
      { heading: "Communication" },
      {
        icon: "mdi-message-outline",
        text: "Messaging",
        path: "/messaging",
        feature: "messaging",
        roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin", "Orbital-Instance-Admin"],
      },
      {
        icon: "mdi-account-group-outline",
        text: "Outreach",
        feature: "campaigns",
        path: "/campaigns",
        roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
        children: [
          {
            icon: "mdi-email-multiple-outline",
            text: "Campaigns",
            path: "/campaigns/manage",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
          {
            icon: "mdi-filter-multiple-outline",
            text: "Segments",
            path: "/campaigns/segments",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
          {
            text: "Mapping",
            path: "/campaigns/mapping/attributes",
            icon: "mdi-approximately-equal",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
          {
            icon: "mdi-file-document-outline",
            text: "Templates",
            path: "/campaigns/templates",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
          {
            icon: "mdi-account-multiple-outline",
            text: "Verified Identities",
            path: "/settings/identities",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin", "Orbital-Instance-Admin"],
          },
          {
            icon: "mdi-timeline-outline",
            text: "Activity",
            path: "/campaigns/activity",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
        ],
      },
      { divider: true },
      { heading: "Administration" },
      {
        icon: "mdi-table-arrow-left",
        text: "Data Import",
        path: "/imports",
        roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
      },
      {
        text: "Automations",
        path: "/settings/automations",
        feature: "automations",
        icon: "mdi-lightning-bolt-outline",
        roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
      },
      {
        icon: "mdi-account-outline",
        text: "Users",
        path: "/users",
        roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
      },
      {
        icon: "mdi-format-list-text",
        text: "Forms",
        path: "/forms",
        roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
      },
      {
        icon: "mdi-swap-horizontal",
        text: "Integrations",
        path: "/integrations",
        roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
        children: [
          {
            icon: "mdi-connection",
            text: "Connections",
            path: "/integrations/",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
          {
            icon: "mdi-transit-connection-variant",
            text: "Mappers",
            path: "/integrations/mappers",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
          {
            icon: "mdi-webhook",
            text: "Incoming Events",
            path: "/integrations/events",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
          {
            icon: "mdi-folder-network",
            text: "FTP",
            path: "/integrations/ftp",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
          {
            icon: "mdi-api",
            text: "API Clients",
            path: "/api-clients",
            roles: ["Orbital-Platform-Admin"],
          }
        ]
      },
      {
        icon: "mdi-tools",
        text: "Settings",
        path: "/settings",
        roles: ["Orbital-Platform-Admin"],
        children: [
          {
            icon: "mdi-home-outline",
            text: "Organization",
            path: "/organization",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
          {
            icon: "mdi-view-agenda-outline",
            text: "Instances",
            feature: "instances",
            path: "/instances",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },

          {
            icon: "mdi-account-group-outline",
            text: "Custom Roles",
            feature: "custom-roles",
            path: "/settings/roles",
            roles: ["Orbital-Platform-Admin"],
          },
          {
            icon: "mdi-account-tie",
            text: "Provider Roles",
            path: "/settings/provider-roles",
            roles: ["Orbital-Platform-Admin"],
          },
          {
            icon: "mdi-text-box-outline",
            text: "Custom Fields",
            path: "/settings/custom-fields",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
          {
            text: "Tasks",
            path: "/settings/task-types",
            feature: "tasks",
            icon: "mdi-format-list-bulleted",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
          {
            text: "Plans",
            path: "/plans",
            icon: "mdi-map-legend",
            feature: "tasks",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
          {
            text: "Messaging",
            path: "/settings/message-templates",
            icon: "mdi-email-multiple-outline",
            feature: "messaging",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
          {
            text: "Import Mappings",
            path: "/settings/import-mappings",
            icon: "mdi-file-table-box-multiple-outline",
            roles: ["Orbital-Platform-Admin", "Orbital-Organization-Admin"],
          },
        ],
      },
    ],
  }),
  watch: {
    dark(val) {
      this.$vuetify.theme.dark = val;
      localStorage.setItem("dark_mode", val);
    },
  },
  async created() {
    this.menuOpen = localStorage.getItem("menuOpen") == "false" ? false : true;
    this.bottomMenuOpen = localStorage.getItem("bottomMenuOpen") == "true" ? true : false;
    if (this.checkFeature("messaging")) {
      this.LOAD_COUNTS();
    }
    this.loading = true;
    this.loadNotificationCount();

    // Set icon and logo based on current route
    const instanceId = this.$route.params.id;
    const isInstancePage = this.$route.path.startsWith("/instances/") && instanceId;

    if (isInstancePage && this.instance?.icon) {
      this.staticIcon = this.instance.icon;
    } else if (this.organization?.instance?.icon) {
      this.staticIcon = this.organization.instance.icon;
    } else if (this.organization?.icon) {
      this.staticIcon = this.organization.icon;
    }

    if (isInstancePage && this.instance?.logo) {
      this.staticLogo = this.instance.logo;
    } else if (this.organization?.instance?.logo) {
      this.staticLogo = this.organization.instance.logo;
    } else if (this.organization?.logo) {
      this.staticLogo = this.organization.logo;
    }

    this.loading = false;
  },
  mounted() {
    this.dark = localStorage.getItem("dark_mode") == "true";
    const user = this.user;
    Intercom({
      app_id: 'j9ipdmyw',
      user_id: user.id,
      name: user.name,
      email: user.userID,
      created_at: user.createdAt,
    });
  },
  beforeUnmount() {
    clearInterval(this.polling);
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("organization", ["organization"]),
    ...mapState("instances", ["instance"]),
    ...mapState("messaging", ["loadingConversations", "counts"]),
    ...mapGetters("messaging", ["getUnreadMessageCount"]),
    name() {
      return this.organization?.instance?.name || this.organization?.name;
    },
    encodedID() {
      return this.user ? btoa(this.user?.userID) : null;
    },
    renderUserName() {
      if (!this.user || !this.user?.name) return null;
      let name = this.user.name;
      prefixes.forEach(p => (name = name.replace(p, "").trim()));
      if (name.length > 16) {
        const spaceIndex = name.indexOf(" ");
        name = spaceIndex === -1 ? name.substring(0, 16) : name.substring(0, spaceIndex);
      }
      return name;
    },
    mappedItems() {
      if (!this.organization || !this.user) {
        return this.items.filter(i => {
          return !i.roles && !i.feature;
        });
      }
      return this.items
        .filter(i => {
          return !i.feature || this.checkFeature(i.feature);
        })
        .filter(i => {
          return !i.roles || this.user?.groups?.some(role => i.roles.includes(role));
        })
        .map(item => {
          return {
            ...item,
            children: item.children?.filter(i => {
              return !i.feature || this.checkFeature(i.feature);
            }).map(child => {
              // Process grandchildren if they exist
              if (child.children) {
                return {
                  ...child,
                  children: child.children.filter(gc => {
                    return !gc.feature || this.checkFeature(gc.feature);
                  }).filter(gc => {
                    return !gc.roles || this.user?.groups?.some(role => gc.roles.includes(role));
                  })
                };
              }
              return child;
            }),
            expanded: item.children?.find(c => this.$route.path.includes(c.path)),
          };
        });
    },
    supportUrl() {
      return this.organization.supportUrl;
    },
    icon() {
      return this.staticIcon;
    },
    logo() {
      return this.staticLogo;
    },
    showControlPanel() {
      return false;
    },
    getUnreadCount() {
      const notificationsStore = useNotificationsStore();
      return notificationsStore.getUnreadCount;
    },
    darkMode() {
      return this.$vuetify.theme.dark || this.$vuetify.theme.name == "dark" || this.$vuetify.theme.current.dark;
    },
    hasUnreadChangelogEntries() {
      const lastViewed = localStorage.getItem('changelog_last_viewed');
      if (!lastViewed) return true;

      // Get the latest changelog date from localStorage
      // This will be updated by the Changelog component when it loads
      const latestChangelogDate = localStorage.getItem('changelog_latest_date');

      // If there's no latest changelog date, return false
      if (!latestChangelogDate) return false;

      try {
        // Parse dates and compare them
        const lastViewedDate = new Date(lastViewed);
        const latestDate = new Date(latestChangelogDate);

        // Check if dates are valid
        if (isNaN(lastViewedDate.getTime()) || isNaN(latestDate.getTime())) {
          return false;
        }

        // Compare dates - return true if latest changelog is newer than last viewed
        return latestDate > lastViewedDate;
      } catch (error) {
        console.error('Error comparing changelog dates:', error);
        return false;
      }
    },
  },
  methods: {
    ...mapActions("auth", [AUTH_LOGOUT]),
    ...mapActions("messaging", [LOAD_COUNTS]),
    ...mapActions("organization", [LOAD_ORGANIZATION]),
    pollNotifications() {
      this.polling = setInterval(() => {
        if (!this.loadingNotifications) {
          this.LOAD_COUNTS();
          this.loadNotificationCount();
        }
      }, 1200000);
    },
    logout() {
      this.AUTH_LOGOUT();
    },
    loadNotificationCount() {
      const notificationsStore = useNotificationsStore();
      notificationsStore.loadNotificationCount();
    },
    renderBadgeColor(elem) {
      if (this.getUnreadMessageCount == 0 && elem.path.replace("/", "") == "messaging") return "grey lighten-1";
      return elem.path.replace("/", "") == this.$route.name ? "green" : "primary";
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      localStorage.setItem("menuOpen", this.menuOpen);
    },
    toggleBottomMenu() {
      this.bottomMenuOpen = !this.bottomMenuOpen;
      localStorage.setItem("bottomMenuOpen", this.bottomMenuOpen);
    },
    openControlPanel() {
      const width = 340;
      const height = 600;
      const features = `width=${width},height=${height},menubar=no,toolbar=no,location=no,resizable=no,scrollbars=no,status=no`;
      window.open(this.organization?.settings?.amazonConnectContactUrl ?? this.organization?.settings?.amazonConnectUrl, "_blank", features);
    },
    checkRoute(route) {
      if (route == "/") return this.$route?.path == "/";

      // Special case for Dashboard - highlight for all report-related routes
      if (route === "/dashboard" && (
        this.$route?.path?.includes("/reports") ||
        this.$route?.path?.includes("/report/") ||
        this.$route?.path?.includes("/dashboard/reports") ||
        this.$route?.path?.match(/\/reports?\/(preview|drafts|json)/)
      )) {
        return true;
      }

      return this.$route?.path?.includes(route);
    },
  },
};
</script>

<style lang="css" scoped>
/* Target the gap between icon and text */
:deep(.v-list-item__prepend) {
  margin-right: 4px !important;
  width: 24px !important;
  min-width: 24px !important;
}

:deep(.v-list-item__content) {
  padding-left: 0 !important;
}

.dense-list .v-list-item {
  min-height: 32px !important;
}

/* Logo styling */
.logo-container {
  overflow: hidden;
}

.logo-image {
  object-fit: contain !important;
  max-height: 60px;
}

:deep(.v-img__img) {
  object-fit: contain !important;
}

/* Submenu styling */
.submenu-item {
  /* padding-left: 36px !important; */
  background-color: rgba(0, 0, 0, 0.03);
}
</style>

<style scoped lang="scss">
#ccp {
  position: absolute;
  top: 0;
  right: 0;
  width: 500;
  height: 500;
  overflow: hidden;
}

.nav-drawer {
  :deep(.v-list-item) {
    min-height: 32px !important;
  }

  :deep(.v-list-item__prepend) {
    margin-right: 4px !important;
  }

  :deep(.v-list-group__items .v-list-item) {
    padding-inline-start: calc(var(--indent-padding) - 42px) !important;
    min-height: 32px !important;
  }

  :deep(.v-list-group__items .v-list-group__items .v-list-item) {
    padding-inline-start: calc(var(--indent-padding) - 90px) !important;
    min-height: 28px !important;
  }
}

:deep(.v-list-item--density-compact:not(.v-list-item--nav).v-list-item--one-line) {
  padding-inline-start: calc(var(--indent-padding) - 48px) !important;
  min-height: 32px !important;
}

:deep(.v-navigation-drawer--rail .v-list-group__items .v-list-item) {
  padding-inline-start: 16px !important;
  min-height: 32px !important;
}

:deep(.v-navigation-drawer--rail .v-list-group__items .v-list-group__items .v-list-item) {
  padding-inline-start: 24px !important;
  min-height: 28px !important;
}

.navbar-link.grandchild {
  font-size: 0.75rem;
}

.v-list-item-title {
  font-size: 0.875rem !important;
}

:deep(.v-list-subheader) {
  font-size: 0.7rem !important;
  letter-spacing: 0.1em;
  opacity: 0.7;
  padding-top: 12px;
  padding-bottom: 4px;
}

/* Animation styles */
.rotate-icon {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.bottom-menu-content {
  overflow: hidden;
}

:deep(.v-expand-transition-enter-active),
:deep(.v-expand-transition-leave-active) {
  transition: all 0.3s ease-out;
}

:deep(.v-expand-transition-enter-from),
:deep(.v-expand-transition-leave-to) {
  opacity: 0;
}
</style>
